import { useQuoteApiServiceGetApiQuoteApiLanguage } from "../openapi/api/queries/queries";

import { VMLanguages } from "@4pace-cpq/core";
import { useLanguage } from "@4pace-cpq/core";
import { useSearch } from "@tanstack/react-router";

export async function fetchCfgObjectIds(): Promise<string[]> {
  try {
    const response = await fetch(
      "/preview/api/3pq-cs/v2/configuration/configurators",
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data = await response.json();
    return data.map((item: { id: string }) => item.id);
  } catch (error) {
    console.error("Failed to fetch configuration objects:", error);
    return [];
  }
}

export const LanguageInit = (): VMLanguages | undefined => {
  const { language: searchLanguage } = useSearch({ strict: false });
  const { selectedLanguage, languages } = useLanguage();
  const { data: quoteLanguage } = useQuoteApiServiceGetApiQuoteApiLanguage();
  const savedLanguage = localStorage.getItem("selectedLanguageId");
  const appLanguage = savedLanguage ? savedLanguage : "en-US";

  let language;
  if (searchLanguage) {
    //console.log("a) Try setting language from searchLanguage", searchLanguage);

    language = languages?.find(
      (lang) => lang.languageCode?.split("-")[0] === searchLanguage,
    );
    localStorage.setItem("selectedLanguageId", language?.languageCode ?? "");
  }
  if (!language && quoteLanguage) {
    //console.log("c) Try setting language from quoteLanguage", quoteLanguage);
    language = languages?.find(
      (lang) => lang.languageCode?.split("-")[0] === quoteLanguage,
    );
  }
  if (!language && selectedLanguage) {
    /* console.log(
      "b) Try setting language from selectedLanguage",
      selectedLanguage,
    ); */
    language = selectedLanguage;
  }
  if (!language) {
    //console.log("d) Set language from appLanguage", appLanguage);
    language = languages?.find(
      (lang) => lang.languageCode?.split("-")[0] === appLanguage?.split("-")[0],
    );
  }
  localStorage.setItem("selectedLanguageId", language?.languageCode ?? "");
  /* console.log("languages", languages);
  console.log("searchLanguage", searchLanguage);
  console.log("quoteLanguage", quoteLanguage);
  console.log("selectedLanguage", selectedLanguage);
  console.log("=====> language", language); */
  return language;
};
